__turbopack_context__.v({
  "error": "phone-input-module-sass-module__REPSra__error" + " " + __turbopack_context__.i(348263)["error"],
  "fieldError": "phone-input-module-sass-module__REPSra__fieldError" + " " + __turbopack_context__.i(348263)["fieldError"],
  "oneCountry": "phone-input-module-sass-module__REPSra__oneCountry",
  "phoneInput": "phone-input-module-sass-module__REPSra__phoneInput",
});
